module.exports = __webpack_public_path__ + "static/img/qrcode_for_gh_fa109cc0270a_258.0242f035.jpg";